import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const CircularProgressWithLabel = ({ value, icon }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={value} thickness={6} sx={{ borderRadius: '4px' }} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          <div className="icon">
            <img src={icon} alt="icon" />
          </div>
        </Typography>
      </Box>
    </Box>
  );
};

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

const ProgressCompDzIndicator = ({ totalMaterials, sentMaterials, iconImg }) => {
  const [percentage, setPercentage] = useState(0);
  useEffect(() => {
    if (totalMaterials > 0) {
      const calculatedPercentage = (sentMaterials / totalMaterials) * 100;
      setPercentage(calculatedPercentage);
    }
  }, [totalMaterials, sentMaterials]);

  return <CircularProgressWithLabel value={percentage} icon={iconImg} />;
};

ProgressCompDzIndicator.propTypes = {
  totalMaterials: PropTypes.number.isRequired,
  sentMaterials: PropTypes.number.isRequired,
};

export default ProgressCompDzIndicator;
